/**
 * Renders the entire Layers Panel (the "root" of the layer list).
 * - On mount, fetches themas from /Api/thema or uses props.layers_ref from Redux
 * - Renders an Accordion of <ThemasStack> for each thema
 * - Includes “Disable all” buttons for desktop & mobile
 * - The layout/styling is the same as your original code
 */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Accordion, Spinner } from "react-bootstrap";
import axios from "axios";
import Icon from "@mdi/react";
import { mdiSync } from "@mdi/js";

// Import your ThemasStack
import ThemasStack from "./ThemasStack";

import MapLayerServices from "../../../services/MapLayerServices";
// You can import your SCSS or CSS here
import Styles from "./LayerPanel.scss";

const LayersPanel = (props) => {
  const [layers, setLayers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const mapLayerService = new MapLayerServices();

  // for scroll container height
  const winHeight = document.documentElement.clientHeight || 600;

  // 1) fetch themas from server or from Redux
  const fetchData = () => {
    setIsLoading(true);
    if (props.layers_ref && props.layers_ref.length > 0) {
      setLayers(props.layers_ref);
      setIsLoading(false);
    } else {
      axios
        .get("/Api/thema")
        .then((result) => {
          setLayers(result.data);
          props.setLayersRef(result.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  // 2) Clear all layers except cadastre:parcelles
  const clearStack = () => {
    mapLayerService.clearLayerButParcelle();
    props.clearLayersStack();
    // Also reflect that in localStorage
    localStorage.setItem("layers_stack", JSON.stringify(["cadastre:parcelles"]));
  };

  return (
    <div className="layer-panel">
      {/* Desktop “Disable all” */}
      <div
        className="d-none d-md-flex w-full rounded-top justify-content-between align-items-center shadow mb-3"
        onClick={clearStack}
        style={{
          height: "46px",
          fontSize: "11px",
          backgroundColor: "var(--theme-page-background)",
          padding: "13px 30px 13px 45px",
          cursor: "pointer",
        }}
      >
        <div
          className="flex items-center m-0 w-100 text-center label-color"
          style={{ fontSize: "12px" }}
        >
          Désactiver toutes les couches
        </div>
        <div
          className="d-flex spi flex-column justify-center items-center rounded shadow-sm highlight"
          style={{
            backgroundColor: "var(--theme-page-background-alternate)",
            padding: "5px",
          }}
        >
          <Icon path={mdiSync} color={"var(--theme-primary)"} size={0.9} />
        </div>
      </div>

      {/* Mobile “Disable all” */}
      <div
        className="w-full mb-3 d-block d-md-none"
        style={{ paddingTop: "16px", fontSize: "11px" }}
        onClick={clearStack}
      >
        <div className="ue-layer-panel-btn-clear d-flex justify-content-center align-items-center w-100">
          <div className="ue-btn-clear-icon">
            <Icon
              path={mdiSync}
              color={"var(--theme-primary)"}
              size={2}
              style={{ marginRight: "30px" }}
            />
          </div>
          <span> Désactiver toutes les couches</span>
        </div>
      </div>

      {/* The container with themas */}
      <div
        className="card-body p-0"
        style={{
          maxHeight: winHeight - 180 + "px",
          overflow: "auto",
          backgroundColor: "var(--theme-page-background)",
        }}
      >
        {!isLoading ? (
          <Accordion style={{ paddingRight: "10px", paddingLeft: "10px" }}>
            {layers.map((thema, idx) => {
              // parse the rub_stack
              let parsedData = [];
              try {
                parsedData = JSON.parse(thema.rub_stack);
              } catch (e) {
                console.warn("Could not parse rub_stack:", e);
              }
              return (
                <ThemasStack
                  key={idx}
                  title={thema.title}
                  refid={thema.id}
                  data={parsedData}
                />
              );
            })}
          </Accordion>
        ) : (
          <div className="text-center my-2">
            <Spinner animation="border" size="sm" />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  layers_ref: state.LayersReducer.layers_refs,
});

const mapDispatchToProps = (dispatch) => ({
  setLayersRef: (data) => dispatch({ type: "SET_LAYERS_REF", data }),
  clearLayersStack: () => dispatch({ type: "CLEAR_LAYERS_STACK" }),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayersPanel);
